import React from 'react';

const IconI = props => (<svg viewBox="0 0 8 17" width="8px" height="17px" {...props}>
  <path d="M0.295783865,8.05779214 C1.45984637,6.82947605 3.53764837,4.59405885 5.75416584,5.06387172 C7.23184415,5.3770803 6.64075054,8.21048844 3.98088501,13.5640961 C6.74017561,12.4148351 7.72554506,12.2969533 6.93699337,13.2104507 C5.75416584,14.5806968 2.30400305,17.0708196 0.80687783,15.6163352 C-0.19120565,14.646679 0.389450707,12.1271646 2.5488469,8.05779214 C0.27076321,8.87666954 -0.480257801,8.87666954 0.295783865,8.05779214 Z" />
  <circle cx="6" cy="2" r="2" />
</svg>);

export default IconI;
